import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/usePortal'

import type { PortalModel } from '@models/types'

const Portal = (props: { portal: Partial<PortalModel> }) => {
  const { portal } = props
  const { id, short_code, title } = portal

  const { editPortalUrl } = generateUrls(portal)

  return (
    <DashboardModuleListItem
      href={editPortalUrl}
      secondaryText={short_code}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default Portal
